/**
 * 记录一个路由的访问时间，表示一个模块的打开时间，供后续性能分析使用
 * @param {Object} menu 菜单对象
 */
export function recodeMenuOpenTime (menu) {
  if (!menu) return
  try {
    const now = Date.now()
    window.__ERP_MENU_OPEN_TIME__ = window.__ERP_MENU_OPEN_TIME__ || {}
    window.__ERP_MENU_OPEN_TIME__[menu.id] = now
  } catch (e) {
    console.warn(e)
  }
}



// WEBPACK FOOTER //
// ./src/layout/router/helpers/recode-moudle-open-time.js